import exodus from './exodus.png'
import metamask from './metamask.png'
import safepal from './safepal.png'
import trust from './Trust.png'

const depoIMG = {
    exodus: exodus,
    metamask: metamask,
    safepal: safepal,
    trust: trust
}

export default depoIMG;